import React from "react";

import Container from "@mui/material/Container";

import twitter from "../../images/footertwitter.png";
import insta from "../../images/footerinsta.png";
import zoom from "../../images/footerzoom.png";
import logo from "../../images/logofooter.png";

import { Link } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";

const Footer = () => {
  return (
    <footer class="footer">
      <ScrollToTop/>
      <Container>
        <div class="row">
          <div class="footer-col---logoimg">
            <h4>
              <img className="QL---Footer---logoimg" src={logo} />
            </h4>

            <div className="QL__Sec__Footer__Intro">
              LearnQuranQuick is an all-in-one platform where people can enhance
              their Quran learning and reading skills with the help of the
              finest Quran tutors in Pakistan.
              <br />
              <br />
            </div>
            <div className="social-links">
              follow us on:
              <a href="https://twitter.com/quranschool57">
                <i className="fabfa-twitter">
                  <img src={twitter} />
                </i>
              </a>
              <a href="https://www.instagram.com/learnquranquick/">
                <i className="fab fa-instagram">
                  <img src={insta} />
                </i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin-in">
                  <img src={zoom} />
                </i>
              </a>
            </div>
          </div>
          <div class="footer-col1">
            <h4>Quick links</h4>
            <ul>
              <li>
                <Link to="/">Home </Link>
              </li>
              <li>
                <Link to="/AboutUs">About us</Link>
              </li>
              <li>
                <Link to="/Courses">Courses</Link>
              </li>
              <li>
                <Link to="/Pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/Contact">Contact</Link>
              </li>
              <li>
                <Link to="/Registration">Register</Link>
              </li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>Subjects</h4>
            <ul>
              <li>
                <Link to="/courses/quranwithtajweed">
                  Qur'an Reading With Tajweed
                </Link>
              </li>
              <li>
                <Link to="/courses/qurantranslation">Qur'an Translation</Link>
              </li>
              <li>
                <Link to="/courses/basicquranreading">
                  Basic Qur'an Reading
                </Link>
              </li>
              <li>
                <Link to="/courses/learntenqirat">Learn Ten Qirat</Link>
              </li>
              <li>
                <Link to="/courses/quranmemorization">Qur'an Memorization</Link>
              </li>
              <li>
                <Link to="/courses/basicislamicknowledge">
                  Basic Islamic Knowledge
                </Link>
              </li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>Contact us</h4>
            <ul>
              <li>
                <div className="simple">Phone No: +447748343503</div>
              </li>
              <li>
                <div className="simple">Email: info@learnquranquick.com</div>
              </li>
              <li>
                <div className="simple">Address: PWD Building</div>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </footer>
  );
};
export default Footer;
